import React from "react";
import { string, bool, node, shape, object } from "prop-types";
import { motion } from "framer-motion";
import { isMobileOnly } from "react-device-detect";
import useStartMotion from "../../../hooks/use-start-motion";
import { fadeInVariants } from "../../../utils/animations";

const sizing = `
  max-w-1440 w-full
  px-5 lg:px-20 2xl:px-10
  py-5 lg:py-10
  mx-auto
`;

const fullWidthSizing = `
  min-w-[100vw] mx-auto
`;

function Section({
  children,
  className,
  fullWidth,
  animations,
  fullWidthCarousel,
  animationsVariant,
  style,
  id,
}) {
  const { ref, controls } = useStartMotion();

  return (
    <motion.section
      className={`
        relative
        ${fullWidth ? fullWidthSizing : sizing}
        ${className}
      `}
      ref={ref}
      animate={controls}
      initial={isMobileOnly || !animations ? "visible" : "hidden"}
      variants={animationsVariant}
      transition={{ delay: 0.4, duration: 0.8 }}
      style={style}
      id={id}
    >
      {fullWidth && !fullWidthCarousel ? (
        <div className={sizing}>{children}</div>
      ) : (
        children
      )}
    </motion.section>
  );
}

Section.propTypes = {
  children: node.isRequired,
  className: string,
  fullWidth: bool,
  animations: bool,
  fullWidthCarousel: bool,
  animationsVariant: shape({
    hidden: object,
    visible: object,
  }),
  style: object,
  id: string,
};

Section.defaultProps = {
  className: "",
  fullWidth: false,
  animations: true,
  fullWidthCarousel: false,
  animationsVariant: fadeInVariants,
  style: null,
  id: null,
};

export default Section;
